import { ReactElement } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import styles from './AppLogo.module.less';
import { AppLogoUrl } from '../../core/CcxEnv';
import User from '../../types/User';

export type AppLogoProps = {
    user?: User | undefined;
};

function AppLogo({ user }: AppLogoProps): ReactElement {
    const history = useHistory();

    const handleLogoClick = () => {
        history.push(`/projects/${user?.getOrganizationId()}/data-stores`);
    };

    return (
        <div className={styles.AppLogo}>
            <NavLink
                to={'#'}
                data-testid="AppLogoLink"
                onClick={(e) => {
                    e.preventDefault();
                    handleLogoClick();
                }}
            >
                <img src={AppLogoUrl} alt="Logo" data-testid="AppLogoImage" />
            </NavLink>
        </div>
    );
}

export default AppLogo;
